<template>
    <header class="header">
        <div>
            <h1>
                <router-link to="/" class="icon_wrap">
                    <img src="img/logo.png" alt="디지털 성매매 시민참여 플랫폼 관리자" />
                </router-link>
            </h1>
        </div>

        <div class="area_status" v-show="CommonUtils.checkAuth()">
            <div>
                <RouterLink :to="{ name: 'newClntList' }">
                    [신규 내담자 확인 대기 건 수 :
                    <span>{{ CommonUtils.numberFormat(state.cntWaitForClient) }}건</span>
                    ]
                </RouterLink>
            </div>
            <div>
                <RouterLink :to="{ name: 'newCnslList' }">
                    [신규 상담일지 승인 대기 건 수 :
                    <span>{{ CommonUtils.numberFormat(state.cntWaitForCounsel) }}건</span>
                    ]
                </RouterLink>
            </div>
            <div>
                <RouterLink :to="'#'">
                    [수정/삭제 승인(
                    <span @click="router.push({ name: 'accessRequestClient' })">내담자: {{ CommonUtils.numberFormat(state.cntClient) }}건</span>
                    /
                    <span @click="router.push({ name: 'accessRequestCounsel' })">상담일지: {{ CommonUtils.numberFormat(state.cntCounsel) }}건</span>
                    )]
                </RouterLink>
            </div>
        </div>

        <div class="area_info">
            <div>
                <span class="user_name">[{{ user.userInfo.name }}]</span>
                님 이 로그인 하셨습니다.
            </div>
            <div class="user_info">(권한코드: {{ user.userInfo.auth }}, 부서: {{ user.userInfo.team }})</div>
            <div><button class="btnLogout" @click="logout" type="button">로그아웃</button></div>
        </div>
    </header>
</template>

<script lang="ts">
    import {
        apiService,
        onMounted,
        reactive,
        router,
        userStore,
        returnCode,
        globalStore,
        watch,
        types,
        useRoute,
        ref,
        onUnmounted,
        CommonUtils,
        onActivated,
    } from "@/BaseComponent";

    export default {
        props: {
            cntClient: { type: Number, default: 0 },
            cntCounsel: { type: Number, default: 0 },
            cntWaitForClient: { type: Number, default: 0 },
            cntWaitForCounsel: { type: Number, default: 0 },
        },
        setup(props: any) {
            const user = userStore();
            const route = useRoute();
            const global = globalStore();

            const userInfo = reactive({
                info: {} as any,
                password: "" as string,
                password_ck: "" as string,
                name: user.userInfo?.name as string,
                id: user.userInfo?.id as string,
            });
            const state = reactive({
                searchDate: [] as any,
                userMenu: false,
                settingMenu: false,
                isModalOpen: false,
                isUserModal: false,
                isKeywordModal: false,
                isHelperModal: false,
                position: [] as any,
                dept: [] as any,
                isLogin: false as boolean,
                isFloat: false as boolean,

                menuOverFlag: false as boolean,
                headerClass: [] as Array<string>,
                isScroll: false as boolean,

                cntClient: 0 as number,
                cntCounsel: 0 as number,
                cntWaitForClient: 0 as number,
                cntWaitForCounsel: 0 as number,
            });

            const modal = reactive({
                title: "",
                customClass: {
                    wrap: [] as Array<string>,
                    button: [] as Array<string>,
                },
                list: [] as any,
                fields: [] as any,
                cancel: "",
                confirm: "",
                type: "nation",
                actionCode: 0 as number,
                isBtn: true as boolean,
            });

            const scrollY = ref(0);

            onMounted(() => {
                initStatus();
            });

            onActivated(() => {
                checkLogin();
                window.addEventListener("scroll", handleScroll);

                state.headerClass = route.meta.headerClass as string[];
                initStatus();
            });

            onUnmounted(() => {
                window.removeEventListener("scroll", handleScroll);
            });

            watch(user, () => {
                checkLogin();

                if (state.isLogin)
                    if (CommonUtils.checkAuth()) {
                        getAccessRequestStatus();
                    }
            });

            watch(
                () => props.cntClient,
                () => (state.cntClient = props.cntClient),
            );
            watch(
                () => props.cntCounsel,
                () => (state.cntCounsel = props.cntCounsel),
            );
            watch(
                () => props.cntWaitForClient,
                () => (state.cntWaitForClient = props.cntWaitForClient),
            );
            watch(
                () => props.cntWaitForCounsel,
                () => (state.cntWaitForCounsel = props.cntWaitForCounsel),
            );

            const initStatus = async () => {
                if (props.cntClient) state.cntClient = props.cntClient;
                if (props.cntCounsel) state.cntCounsel = props.cntCounsel;
                if (props.cntWaitForClient) state.cntWaitForClient = props.cntWaitForClient;
                if (props.cntWaitForCounsel) state.cntWaitForCounsel = props.cntWaitForCounsel;

                if (CommonUtils.checkAuth()) {
                    await getAccessRequestStatus();
                }
            };

            const handleScroll = () => {
                scrollY.value = window.scrollY;

                if (scrollY.value >= 100) {
                    state.isScroll = true;
                } else {
                    state.isScroll = false;
                }
            };

            const checkLogin = () => {
                if (user.isLogin()) {
                    state.isLogin = true;
                } else {
                    state.isLogin = false;
                }
            };

            const handleOutsideClick = () => {
                state.userMenu = false;
            };

            const handleOutsideClick2 = () => {
                state.settingMenu = false;
            };

            const logout = async () => {
                if (user && user.accessToken != null && user.accessToken != "") {
                    let res: types.BaseResponse = await apiService.base.logout();

                    if (res !== null && res.returnCode === 0) {
                        state.isLogin = false;
                        user.$reset();
                        global.$reset();
                        router.replace("/login");
                    } else {
                        state.isLogin = true;
                    }
                }
            };

            const openMenu = (menuIdx: number) => {
                switch (menuIdx) {
                    case 0:
                        state.userMenu = !state.userMenu;
                        state.settingMenu = false;
                        break;
                    case 1:
                        state.settingMenu = !state.settingMenu;
                        state.userMenu = false;
                        break;
                }
            };

            const getAccessRequestStatus = async () => {
                const res = await apiService.accessRequest.status();
                if (res.returnCode === 0) {
                    state.cntClient = res.cntClient;
                    state.cntCounsel = res.cntCounsel;
                    state.cntWaitForClient = res.cntWaitForClient;
                    state.cntWaitForCounsel = res.cntWaitForCounsel;
                }
            };

            return {
                state,
                userInfo,
                modal,
                openMenu,
                logout,
                router,
                handleOutsideClick,
                handleOutsideClick2,
                user,
                CommonUtils,
            };
        },
    };
</script>

<style scoped>
    header.header {
        display: flex;
        justify-content: space-between;
    }

    .area_info,
    .area_status {
        display: flex;
        justify-items: end;
        align-items: center;
        gap: 5px;
    }
    .area_status {
        max-width: 950px;
        flex-wrap: wrap;
    }

    .area_info > div {
        /* margin-left: 15px; */
        font-weight: 400;
        font-size: 18px;
        line-height: 100%;
    }

    .area_info > div .user_name,
    .area_info > div.user_info {
        font-weight: 500;
    }
    .area_info > div button.btnLogout {
        background-color: #31a6d8;
        border-radius: 5px;
        padding: 2px 10px;
        color: white;
        border: 0;
        font-weight: 500;
        font-size: 18px;
    }

    .area_status a {
        font-size: 15px;
    }
    .area_status > div a span {
        font-weight: bold;
        font-size: 16px;
    }
</style>
